module.exports = __webpack_public_path__ + "fonts/lato-light-latin.8370ea4.woff";